import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">专题合集</h2>
          <p className="text-foreground-500 text-sm mt-2">深度追踪，系统吃瓜——按主题分类的完整爆料档案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a key={item.id} href="#cards" className="group bg-background-100 rounded-lg p-5 border border-background-200/60 hover:border-primary-300 transition-colors no-underline cursor-pointer">
              <div className="flex items-center justify-between mb-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-folder-3-line text-lg"></i>
                </span>
                <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">{item.count}</span>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}